﻿import { initCarousels } from "@/sharedComponents/Carousel/Carousel"

function initNewsItem() {
    initCarousels();
}

window.addEventListener("load", () => {
    initNewsItem();
});